import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './questionPackagesState';
import { extraReducers } from './form';

const questionPackagesSlice = createSlice({
  name: 'questionPackages',
  initialState,
  reducers: {},
  extraReducers
});

export const questionPackagesReducer = questionPackagesSlice.reducer;
